import { getMaybeRefValue } from '~/utils/getMaybeRefValue'

type viewPortSizes = 'sm' | 'md' | 'lg' | 'xl'
type params = Partial<{
  target: MaybeRef<HTMLElement | Element> | null
  lessThan: viewPortSizes | null
  GreaterThan: viewPortSizes | null
}>

export const useFocus = () => {
  const { y: windowY } = useWindowScroll({ behavior: 'smooth' })
  const { $viewport } = useNuxtApp()

  const focus = ({ target, lessThan, GreaterThan }: params) => {
    const el = getMaybeRefValue(target)
    if (!el) return

    const isLessThan = lessThan ? $viewport.isLessThan(lessThan) : true
    const isGreaterThan = GreaterThan ? $viewport.isGreaterThan(GreaterThan) : true

    if (!isLessThan || !isGreaterThan) return

    const { y } = el.getBoundingClientRect()
    const offSet = 30 + (document.getElementById('header-container')?.offsetHeight ?? 0)
    windowY.value = y + windowY.value - offSet
  }

  return focus
}
